const dateTimeFormatter = (value?: string): string | undefined => {
  return value?.replace(/ /g, 'T');
};

export {
  dateTimeFormatter,
};
